import React, {useEffect, useState} from "react";
import {HelpHttp} from "helpers/HelpHttp";
import SpinnerBootrap from "components/SpinnerBootrap";
import UserCrudTable from "./UserCrudTable";
import Swal from "sweetalert2";
import {Button, Modal, OverlayTrigger, Spinner, Tooltip} from "react-bootstrap";
import CrudErrors from "components/CrudErros";
import RequestError from "components/RequestError";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import {HelpFunctions} from "helpers/HelpFunctions";
import {trackPromise} from 'react-promise-tracker';

const initialForm = {
    _id: null,
    names: '',
    paternalSurname: '',
    maternalSurname: '',
    email: '',
    password: '',
    repeatPassword: '',
    rol: []
};
const {REACT_APP_API} = process.env;
let roles = [];

const UserCrud = () => {
    // Modal Create ini
    const [showCreate, setShowCreate] = useState(false);
    const handleCloseCreate = () => {
        roles = []
        setShowCreate(false);
        setErrors(null);
    }
    const handleShowCreate = () => {
        roles = []
        setShowCreate(true);
    }
    // Modal Create fin

    // Modal Edit ini
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => {
        roles = []
        setShowEdit(false);
        setErrors(null);
        handleReset(); // Si edita y le da a cerrar, dataToEdit ya tiene datos y si da nuevo y graba, este actualiza
    }
    const handleShowEdit = () => setShowEdit(true);
    // Modal Edit fin

    // Modal UpdatePass ini
    const [showUpdatePass, setShowUpdatePass] = useState(false);
    const handleCloseUpdatePass = () => {
        setShowUpdatePass(false);
        setErrors(null);
        handleReset(); // Si edita y le da a cerrar, dataToEdit ya tiene datos y si da nuevo y graba, este actualiza
    }
    const handleShowUpdatePass = () => setShowUpdatePass(true);
    // Modal UpdatePass fin

    // Modal Update abilities ini
    const [showUpdateAbilities, setShowUpdateAbilities] = useState(false);
    const handleCloseUpdateAbilities = () => {
        setShowUpdateAbilities(false);
        setAbilitiesToSend([]);
        setErrors(null);
        handleReset(); // Si edita y le da a cerrar, dataToEdit ya tiene datos y si da nuevo y graba, este actualiza
    }
    const handleShowUpdateAbilities = () => setShowUpdateAbilities(true);

    // Modal Update abilities fin

    const [users, setUsers] = useState(null);
    const [abilitiesGrouped, setAbilitiesGrouped] = useState(null);
    const [abilities, setAbilities] = useState(null);
    const [abilitiesToSend, setAbilitiesToSend] = useState([]);

    const [requestErrorList, setRequestErrorList] = useState(null);
    // const [requestErrorUpdatePass, setRequestErrorUpdatePass] = useState(null);
    // const [requestErrorUpdateAbil, setRequestErrorUpdateAbil] = useState(null);
    const [errors, setErrors] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingAbilities, setLoadingAbilities] = useState(false);
    const [form, setForm] = useState(initialForm);

    // Pagination
    const [page, setPage] = useState(1);
    const [forcePage, setForcePage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState('');
    const [pagedData, setPagedData] = useState(null);

    let myAbilities = HelpAbility();
    let f = HelpFunctions();

    let api = HelpHttp();
    let url = `${REACT_APP_API}/users`
    let urlAbilities = `${REACT_APP_API}/abilities/toAssign`

    const setDataToEditAndShowModal = (el) => {
        handleShowEdit();
        setForm(el);
        roles = el.rol
    }

    const setDataToUpdatePassAndShowModal = (user) => {
        handleShowUpdatePass();
        user.password = null;
        setForm(user);
    }

    const handleChange = (e) => {
        console.log(e.target.checked, e.target.value)

        if(e.target.name === 'rol'){
            if(e.target.checked){
                roles.push(e.target.value)
            }else{
                roles = roles.filter(rol => rol !== e.target.value)
            }
            console.log(roles)
            setForm({...form, [e.target.name]: [...roles]});
        }else{
            setForm({...form, [e.target.name]: e.target.value});
        }
    }

    const setDataToUpdateAbilitiesAndShowModal = (user) => {
        handleShowUpdateAbilities();
        user.password = null;
        setAbilitiesToSend(user.abilities);
        setForm(user);
    }

    const handleChecked = (e) => {
        if (e.target.checked) {
            setAbilitiesToSend([...abilitiesToSend, e.target.value]);
        } else {
            setAbilitiesToSend(abilitiesToSend.filter(x => x !== e.target.value));
        }
    };

    const handleAllChecked = (e) => {
        if (e.target.checked) {
            setAbilitiesToSend(abilities);
        } else {
            setAbilitiesToSend([]);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(form);
        if (form._id === null) {
            createData(form);
        } else {
            updateData(form);
        }
    }
    const handleSubmitUpdatePass = (e) => {
        e.preventDefault();
        updatePass(form);
    }
    const handleSubmitUpdateAbilities = (e) => {
        e.preventDefault();
        updateAbil(form);
    }
    const handleReset = () => {
        setForm(initialForm);
    }

    const changeForcePageValue = (forcePageValue) => {
        setPage(forcePageValue + 1);
        setForcePage(forcePageValue);
    }

    const handlePageClick = (data) => changeForcePageValue(parseInt(data.selected));

    const focusInitialPage = () => changeForcePageValue(0);

    const handleOnKeyUpSearch = (e) => {
        if (e.keyCode === 13) {
            setSearch(e.target.value);
            focusInitialPage();
        }
    };

    const handleOnChangeLimit = (e) => {
        setLimit(e.target.value);
        focusInitialPage();
    }

    const listUsers = () => {
        url += `?page=${page}&limit=${limit}&search=${search}`;
        trackPromise(api.get(url).then(res => {
            if (res.err) {
                setUsers(null);
                setRequestErrorList(res);
            } else {
                setPagedData(res);
                setUsers(res.docs);
                setRequestErrorList(null);
            }
        }));
    }
    const createData = (data) => {
        setErrors(null);
        let errorsCreate = [];
        if (!data.names) {
            errorsCreate.push({field: 'names', error: 'Los nombres son obligatorios'});
        }
        if (!data.paternalSurname) {
            errorsCreate.push({field: 'paternalSurname', error: 'El apellido paterno es obligatorio'});
        }
        if (!data.email) {
            errorsCreate.push({field: 'email', error: 'El correo electrónico es obligatorio'});
        }
        if (!data.rol) {
            errorsCreate.push({field: 'email', error: 'El rol es obligatorio'});
        }
        if (!data.password) {
            errorsCreate.push({field: 'password', error: 'La contraseña es obligatoria'});
        }
        if (!data.rol.length) {
            errorsCreate.push({field: 'password', error: 'Es necesario al menos un rol'});
        }

        if (errorsCreate.length) {
            setErrors(errorsCreate);
            return;
        }

        if (data.password.length < 8) {
            setErrors([{field: 'password', error: 'La contraseña debe tener mínimo 8 carateres'}]);
            return;
        }

        if (data.password !== data.repeatPassword) {
            setErrors([{field: 'password', error: 'Las contraseñas no coinciden'}]);
            return;
        }

        let options = {body: data, headers: {'content-type': 'application/json'}};
        setLoading(true);
        api.post(url, options).then(res => {
            setLoading(false);
            console.log(res);
            if (res.err) { // Evalua error de la peticion, 404, 503, etc
                setRequestErrorList(res);
            } else {        // si es un 200 con errores de metodos
                if (res.status) {
                    handleCloseCreate();
                    listUsers();
                    Swal.fire('¡Ok!', res.message, 'success');
                } else {
                    setErrors(res.errors);
                }
            }
        });
    }
    const updateData = (data) => {
        let errorsCreate = [];
        if (!data.rol.length) {
            errorsCreate.push({field: 'password', error: 'Es necesario al menos un rol'});
        }
        if (errorsCreate.length) {
            setErrors(errorsCreate);
            return;
        }

        let endPoint = `${url}/${data._id}`;
        let options = {body: data, headers: {'content-type': 'application/json'}};
        setLoading(true);
        api.put(endPoint, options).then(res => {
            setLoading(false);
            if (res.err) {
                setRequestErrorList(res);
            } else {
                if (res.status) {
                    handleCloseEdit();
                    listUsers();
                    Swal.fire('¡Ok!', res.message, 'success');
                } else {
                    setErrors(res.errors);
                }
            }
        });
    }
    const updatePass = (data) => {
        setErrors(null);
        if (!data.password) {
            setErrors([{field: 'password', error: 'La contraseña es obligatoria'}]);
            return;
        } else if (data.password !== data.repeatPassword) {
            setErrors([{field: 'password', error: 'Las contraseñas no coinciden'}]);
            return;
        }

        let endPoint = `${url}/pass/${data._id}`;
        let options = {body: data, headers: {'content-type': 'application/json'}};
        setLoading(true);
        api.put(endPoint, options).then(res => {
            setLoading(false);
            if (res.err) {
                // setRequestErrorUpdatePass(res);
                Swal.fire('¡Error!', 'Ocurrió un error, intente más tarde', 'error');
            } else {
                // setRequestErrorUpdatePass(null);
                if (res.status) {
                    handleCloseUpdatePass();
                    Swal.fire('¡Ok!', res.message, 'success');
                } else {
                    setErrors(res.errors);
                }
            }
        });
    }
    const updateAbil = (data) => {
        setErrors(null);

        let endPoint = `${url}/abil/${data._id}`;
        let options = {body: {abilities: abilitiesToSend}, headers: {'content-type': 'application/json'}};
        setLoading(true);
        api.put(endPoint, options).then(res => {
            setLoading(false);
            if (res.err) {
                // setRequestErrorUpdateAbil(res);
                Swal.fire('¡Error!', 'Ocurrió un error, intente más tarde', 'error');
            } else {
                // setRequestErrorUpdateAbil(null);
                if (res.status) {
                    handleCloseUpdateAbilities();
                    listUsers();
                    Swal.fire('¡Ok!', res.message, 'success');
                } else {
                    setErrors(res.errors);
                }
            }
        });
    }
    const deleteData = (id) => {
        Swal.fire({
            title: '¿Está seguro?',
            text: "¡No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '¡Sí, bórralo!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                const endPoint = `${url}/${id}`;
                let options = {headers: {'content-type': 'application/json'}};
                setLoading(true);
                trackPromise(api.del(endPoint, options).then(res => {
                    setLoading(false);
                    if (res.err) {
                        setRequestErrorList(res);
                    } else {
                        if (res.status) {
                            Swal.fire('¡Eliminado!', res.message, 'success');
                            if (users.length === 1) {
                                changeForcePageValue(forcePage - 1);
                            } else {
                                listUsers();
                            }
                        } else {
                            setErrors(res.errors);
                        }
                    }
                }));
            }
        });
    }

    const checker = (arr, target) => target.every(v => arr.includes(v));
    
    const Ability = ({obj, handleChecked, checked}) => {
        return (
            <div className="form-check form-check-inline">
                <input className="form-check-input" type="checkbox" id={obj._id} name={obj.id} value={obj._id} checked={checked}
                    onChange={handleChecked}/>
                <label className="form-check-label" htmlFor={obj._id}>{obj.title}</label>
            </div>
        );
    }

    useEffect(() => {
        if (showUpdateAbilities) {
            setLoadingAbilities(true);
            api.get(urlAbilities).then(res => {
                setLoadingAbilities(false);
                if (res.err) {
                    setAbilitiesGrouped(null);
                } else {
                    setAbilitiesGrouped(res);

                    const allAbilities = [];
                    res.map(el => allAbilities.push(...el.abilities.map(o => o._id)));
                    setAbilities(allAbilities);
                }
            });
        }
        // eslint-disable-next-line
    }, [showUpdateAbilities]);

    useEffect(() => {
        listUsers();
        // eslint-disable-next-line
    }, [page, limit, search]);
    return (
        <>
            <div className="container">
                <div className="row my-md-4 my-sm-3 my-3">
                    <div className="col-6">
                        <h3>Listado de Usuarios</h3>
                    </div>
                    {myAbilities.has(C.A.USER.CREATE) && <div className="col-6 text-end">
                        <OverlayTrigger placement="top"
                                        overlay={<Tooltip id="tooltip-new-user">Nuevo Usuario</Tooltip>}>
                            <button type="button" className="btn btn-sm btn-primary me-2"
                                    onClick={handleShowCreate}>
                                <i className="bi bi-plus-lg"/></button>
                        </OverlayTrigger>
                    </div>}
                    <div className="col-6 col-md-5">
                        <div className="row align-items-center">
                            <div className="col-auto">
                                <label>Mostrar</label>
                            </div>
                            <div className="col-auto">
                                <select onChange={handleOnChangeLimit} value={limit}
                                        className="form-select form-select-sm">
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            <div className="col-auto"><label>entradas</label></div>
                        </div>
                    </div>
                    <div className="col-6 col-md-7">
                        <div className="row align-items-center justify-content-end">
                            <div className="col-auto">
                                <label htmlFor="imptSearch" className="col-form-label">Buscar por Nombres</label>
                            </div>
                            <div className="col-auto">
                                <input type="search" id="imptSearch" className="form-control form-control-sm"
                                       autoComplete="off" placeholder="Presione Enter" onKeyUp={handleOnKeyUpSearch}/>
                            </div>
                        </div>
                    </div>

                    <div className="col-12">

                        {requestErrorList && <RequestError msg={requestErrorList}/>}
                        {users &&
                        <UserCrudTable pagedData={pagedData} forcePage={forcePage}
                                       handlePageClick={handlePageClick}
                                       setDataToEditAndShowModal={setDataToEditAndShowModal}
                                       setDataToUpdatePassAndShowModal={setDataToUpdatePassAndShowModal}
                                       setDataToUpdateAbilitiesAndShowModal={setDataToUpdateAbilitiesAndShowModal}
                                       deleteData={deleteData}
                        />
                        }
                    </div>
                </div>
            </div>

            <Modal show={showCreate} onHide={handleCloseCreate} backdrop="static" keyboard={false}>
                <Modal.Header closeButton><Modal.Title>Nuevo Usuario</Modal.Title></Modal.Header>
                <Modal.Body>
                    {errors && <CrudErrors errors={errors}/>}
                    <form>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="names" className="col-form-label">Nombres:</label>
                                    <input type="text" autoComplete="off" className="form-control" name="names" id="names"
                                           onChange={handleChange}/>
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="paternalSurname" className="col-form-label">Apellido
                                        Paterno:</label>
                                    <input type="text" autoComplete="off" className="form-control" id="paternalSurname" name="paternalSurname"
                                           onChange={handleChange}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="maternalSurname" className="col-form-label">Apellido
                                        Materno:</label>
                                    <input type="text" autoComplete="off" className="form-control" id="maternalSurname" name="maternalSurname"
                                           onChange={handleChange}/>
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="email" className="col-form-label">Correo Electrónico:</label>
                                    <div className="input-group mb-3">
                                        <span className="input-group-text">@</span>
                                        <input type="email" autoComplete="off" className="form-control" id="email" name="email"
                                               onChange={handleChange}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <label htmlFor="rol" className="col-form-label">Rol</label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="desarrollador" id="desarrollador" name="rol" onChange={handleChange} />
                                        <label className="form-check-label" for="desarrollador">
                                            Desarrollador
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="soporte" id="soporte" name="rol" onChange={handleChange} />
                                        <label className="form-check-label" for="soporte">
                                            Soporte
                                        </label>
                                    </div>

                                    {/* <label htmlFor="rol" className="col-form-label">Rol</label>
                                    
                                    <select className="form-control" id="rol" onChange={handleChange} name="rol" >
                                        <option value="" disabled selected>Seleccione el rol</option>
                                        <option value="desarrollador">Desarrollador</option>
                                        <option value="soporte">Soporte</option>
                                    </select> */}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="password" className="col-form-label">Contraseña:</label>
                                    <input type="password" className="form-control" id="password" name="password" onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="repeatPassword" className="col-form-label">Repita
                                        Contraseña:</label>
                                    <input type="password" className="form-control" id="repeatPassword" name="repeatPassword" onChange={handleChange}/>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseCreate}>
                        Cerrar
                    </Button>
                    {!loading &&
                    <Button variant="primary" onClick={handleSubmit}><i className="bi bi-save"/> Guardar</Button>}
                    {loading && <Button variant="primary" disabled>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                        &nbsp; Guardando...
                    </Button>}
                </Modal.Footer>
            </Modal>

            <Modal show={showEdit} onHide={handleCloseEdit}>
                <Modal.Header closeButton>
                    <Modal.Title>Editar Usuario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {errors && <CrudErrors errors={errors}/>}
                    <form>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="names" className="col-form-label">Nombres:</label>
                                    <input type="text" autoComplete="off" className="form-control" id="names" name="names" value={form.names} onChange={handleChange}/>
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="paternalSurname" className="col-form-label">Apellido
                                        Paterno:</label>
                                    <input type="text" autoComplete="off" className="form-control" id="paternalSurname" name="paternalSurname" value={form.paternalSurname} onChange={handleChange}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="maternalSurname" className="col-form-label">Apellido
                                        Materno:</label>
                                    <input type="text" autoComplete="off" className="form-control" id="maternalSurname" name="maternalSurname" value={form.maternalSurname} onChange={handleChange}/>
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="email" className="col-form-label">Correo Electrónico:</label>
                                    <div className="input-group mb-3">
                                        <span className="input-group-text">@</span>
                                        <input type="email" autoComplete="off" className="form-control" id="email" name="email" value={form.email} onChange={handleChange}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <label htmlFor="rol" className="col-form-label">Rol</label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="desarrollador" id="desarrollador" name="rol" onChange={handleChange} checked={form.rol.some((ro) => ro === "desarrollador")}/>
                                        <label className="form-check-label" for="desarrollador">
                                            Desarrollador
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="soporte" id="soporte" name="rol" onChange={handleChange} checked={form.rol.some((ro) => ro === "soporte")}/>
                                        <label className="form-check-label" for="soporte">
                                            Soporte
                                        </label>
                                    </div>

                                    {/* <input type="check" />
                                    <select className="form-control" id="rol" onChange={handleChange} name="rol" value={form.rol}>
                                        <option value="" disabled selected>Rol</option>
                                        <option value="desarrollador">Desarrollador</option>
                                        <option value="soporte">Soporte</option>
                                    </select> */}
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEdit}>
                        Cerrar
                    </Button>

                    {!loading &&
                    <Button variant="primary" onClick={handleSubmit}><i className="bi bi-save"/> Guardar</Button>}
                    {loading && <Button variant="primary" disabled>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                        &nbsp; Guardando...
                    </Button>}
                </Modal.Footer>
            </Modal>

            <Modal show={showUpdatePass} onHide={handleCloseUpdatePass}>
                <Modal.Header closeButton><Modal.Title>Actualizar Contraseña</Modal.Title></Modal.Header>
                <Modal.Body>
                    <h5>Usuario: {`${form.names} ${form.paternalSurname} ${form.maternalSurname}`}</h5>
                    <small>La contraseña debe tener como mínimo :</small>

                    <div className="row">
                        <div className="col-md-6">
                            <ul>
                                <li><span className="badge bg-light text-dark">8 caracteres</span></li>
                                <li><span className="badge bg-light text-dark">1 letra mayúscula</span></li>
                                <li><span className="badge bg-light text-dark">1 letra minúscula</span></li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <ul>
                                <li><span className="badge bg-light text-dark">1 dígito</span></li>
                                <li><span className="badge bg-light text-dark">1 símbolo</span></li>
                            </ul>
                        </div>
                    </div>
                    {errors && <CrudErrors errors={errors}/>}
                    <form>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="password" className="col-form-label">Contraseña:</label>
                                    <input type="password" className="form-control" id="password" name="password"
                                           onChange={handleChange}/>
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="repeatPassword" className="col-form-label">Repita
                                        Contraseña:</label>
                                    <input type="password" className="form-control" id="repeatPassword" name="repeatPassword"                                          onChange={handleChange}/>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseUpdatePass}>
                        Cerrar
                    </Button>
                    {!loading &&
                    <Button variant="primary" onClick={handleSubmitUpdatePass}><i
                        className="bi bi-save"/> Guardar</Button>}
                    {loading && <Button variant="primary" disabled>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                        &nbsp; Guardando...
                    </Button>}
                </Modal.Footer>
            </Modal>

            <Modal size="lg" show={showUpdateAbilities} onHide={handleCloseUpdateAbilities}>
                <Modal.Header closeButton>
                    <Modal.Title>Autorizaciones: <span
                        className="text-uppercase">{`${form.names} ${form.paternalSurname} ${form.maternalSurname}`}</span></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {errors && <CrudErrors errors={errors}/>}
                    {loadingAbilities && !abilities && <div className="text-center"><SpinnerBootrap/></div>}
                    {abilities && <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="all-abilities" name="all-abilities"
                               checked={checker(abilitiesToSend, abilities)}
                               onChange={handleAllChecked}/>
                        <label className="form-check-label" htmlFor="all-abilities">Marcar todos</label>
                    </div>}
                    {abilitiesGrouped && <div className="row">
                        <div className="col-md-12">
                            {
                                abilitiesGrouped.map(el => <div key={el.entity}>
                                    <h5 className="mt-3 mb-3">{f.titleToAbilities(el.entity)}</h5>
                                    {el.entity === 'parameter' &&
                                    <p><small>Marque los servicios, para actualizar sus parámetros</small></p>}
                                    {
                                        el.abilities.map(o =>
                                            <Ability key={o._id} obj={o} handleChecked={handleChecked}
                                                     checked={abilitiesToSend.includes(o._id)}/>)
                                    }
                                </div>)
                            }
                        </div>
                    </div>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseUpdateAbilities}>
                        Cerrar
                    </Button>
                    {!loading &&
                    <Button variant="primary" onClick={handleSubmitUpdateAbilities}><i className="bi bi-save"/> Guardar</Button>}
                    {loading && <Button variant="primary" disabled>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                        &nbsp; Guardando...
                    </Button>}
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default UserCrud;
